import { render } from "./BeneficiaryResult.vue?vue&type=template&id=79b346eb&scoped=true"
import script from "./BeneficiaryResult.vue?vue&type=script&lang=js"
export * from "./BeneficiaryResult.vue?vue&type=script&lang=js"

import "./BeneficiaryResult.vue?vue&type=style&index=0&id=79b346eb&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b346eb"]])

export default __exports__